import { render } from "./AppStoryphones.vue?vue&type=template&id=6d1f282c&lang=html"
import script from "./AppStoryphones.vue?vue&type=script&lang=js"
export * from "./AppStoryphones.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__